import { reactive as I, computed as u, onMounted as b, onBeforeUnmount as S, openBlock as N, createBlock as T, unref as k, withCtx as C, renderSlot as V } from "vue";
import { CdrModal as h } from "@rei/cedar";
const x = ({
  value: e,
  daysTTL: o
}) => {
  const a = (/* @__PURE__ */ new Date()).valueOf(), t = 864e5, n = typeof o == "number" ? a + t * o : t;
  return JSON.stringify({
    value: e,
    expiry: n
  });
}, f = ({
  key: e,
  value: o,
  daysTTL: a = 60
}) => {
  if (typeof window > "u")
    return;
  const t = x({
    value: o,
    daysTTL: a
  });
  localStorage.setItem(e, t);
}, y = ({
  key: e
}) => {
  if (typeof window > "u")
    return !1;
  const o = localStorage.getItem(e);
  if (!o)
    return !1;
  try {
    const {
      value: a,
      expiry: t
    } = JSON.parse(o);
    return (/* @__PURE__ */ new Date()).valueOf() > t ? (localStorage.removeItem(e), !1) : a;
  } catch {
    return !1;
  }
}, D = ({
  pageViewsEntryKey: e,
  maxPageViews: o,
  daysTTL: a
}) => {
  const t = y({
    key: e
  });
  let n = t;
  return t === !1 ? n = 1 : t < o && (n = t + 1), t !== o && f({
    key: e,
    value: n,
    daysTTL: a
  }), n;
}, E = async ({
  disruptorEntryKey: e,
  daysTTL: o,
  visibilityOverrideFunc: a
}) => {
  let t = !0;
  const n = y({
    key: e
  });
  let i;
  return typeof a == "function" && (i = await a()), (i || n) && (t = !1), t && f({
    key: e,
    value: t,
    daysTTL: o
  }), t;
}, $ = "-modal-seen", q = "-modal-page-views", M = "disruptor", F = (e) => `${e.replace(/-/g, " ")} modal`, P = (e) => `${e}${$}`, K = (e) => `${e}${q}`;
const J = {
  __name: "DisruptorModal",
  props: {
    /* c8 ignore start */
    ariaDescribedby: {
      type: String,
      required: !1,
      default: null
    },
    daysTTL: {
      type: Number,
      required: !1,
      default: 60
    },
    delay: {
      type: Number,
      required: !1,
      default: 6e3
    },
    label: {
      type: String,
      required: !0
    },
    alternateCookieName: {
      type: String,
      required: !1,
      default: null
    },
    id: {
      type: String,
      required: !1,
      default: M,
      validator(e) {
        return e.match(/\s/) === null;
      }
    },
    maxPageViews: {
      type: Number,
      required: !1,
      default: 2
    },
    showTitle: {
      type: Boolean,
      required: !1,
      default: !1
    },
    visibilityOverrideFunc: {
      type: Function,
      required: !1,
      default: null
    }
    /* c8 ignore stop */
  },
  emits: ["update"],
  setup(e, {
    emit: o
  }) {
    const a = e, t = I({
      modalIsOpen: !1,
      displayTimeout: null,
      pageViews: 0
    }), n = o, i = u(() => F(a.id)), m = u(() => P(a.alternateCookieName ? a.alternateCookieName : a.id)), w = u(() => K(a.alternateCookieName ? a.alternateCookieName : a.id)), g = `disruptor-modal__overlay disruptor-modal__overlay--${a.id}`, _ = `disruptor-modal__wrapper disruptor-modal__wrapper--${a.id}`, v = `disruptor-modal__content disruptor-modal__content--${a.id}`, c = (s) => {
      typeof window < "u" && window.metrics && window.metrics.link(s);
    }, O = async () => {
      const {
        daysTTL: s,
        visibilityOverrideFunc: r
      } = a, {
        pageViews: l
      } = t, d = await E({
        disruptorEntryKey: m.value,
        daysTTL: s,
        visibilityOverrideFunc: r
      });
      d && c({
        linkName: `${i.value}_open`
      }), t.modalIsOpen = d, n("update", {
        pageViews: l,
        modalIsOpen: d
      });
    };
    b(() => {
      const {
        maxPageViews: s,
        daysTTL: r
      } = a, l = D({
        pageViewsEntryKey: w.value,
        maxPageViews: s,
        daysTTL: r
      });
      t.pageViews = l, l === s ? t.displayTimeout = setTimeout(() => {
        O();
      }, a.delay) : n("update", {
        pageViews: l
      });
    }), S(() => {
      t.displayTimeout !== null && clearTimeout(t.displayTimeout);
    });
    const p = () => {
      c({
        linkName: `${i.value}_close`
      }), t.modalIsOpen = !1, n("update", {
        modalIsOpen: !1
      });
    };
    return (s, r) => (N(), T(k(h), {
      id: e.id,
      "aria-describedby": e.ariaDescribedby,
      label: e.label,
      opened: t.modalIsOpen,
      "show-title": e.showTitle,
      "data-ui": e.id,
      "overlay-class": g,
      "wrapper-class": _,
      "content-class": v,
      onClosed: p
    }, {
      default: C(() => [V(s.$slots, "default", {
        closeFromContent: p,
        modalIsOpen: t.modalIsOpen
      })]),
      _: 3
    }, 8, ["id", "aria-describedby", "label", "opened", "show-title", "data-ui"]));
  }
};
export {
  J as default
};
